import React,{useEffect,useState}from'react';
async function api(u,o){const r=await fetch(u,{credentials:'include',headers:{'Content-Type':'application/json'},...o}),j=await r.json().catch(()=>({}));if(!r.ok)throw Error(j.error||'Request failed');return j}
const badge={overdue:'bg-red-100 text-red-800',due_soon:'bg-amber-100 text-amber-800',current:'bg-emerald-100 text-emerald-800'};
const label={overdue:'Overdue',due_soon:'Due Soon',current:'Current'};
export default function AdminQAMeetings(){
  const[list,setList]=useState([]),[summary,setSummary]=useState({}),[e,setE]=useState('');
  const[f,setF]=useState({});
  const load=()=>Promise.all([api('/api/dhhs-compliance/qa-meetings'),api('/api/dhhs-compliance/qa-meetings/summary')])
    .then(([a,b])=>{setList(a);setSummary(b)}).catch(x=>setE(x.message));
  useEffect(()=>{load()},[]);
  const add=async()=>{
    if(!f.meeting_date||!f.attendees||!f.minutes_document_path){setE('Meeting date, attendees, and minutes reference are required.');return}
    try{await api('/api/dhhs-compliance/qa-meetings',{method:'POST',body:JSON.stringify(f)});setF({});setE('');load()}
    catch(x){setE(x.message)}
  };
  return <div className="p-5 space-y-5">
    <header>
      <h1 className="text-3xl font-black">Quality Assurance Meetings</h1>
      <p className="text-slate-600">Agency-wide QA committee meetings, required at least every six months. Records are confidential and privileged under RSA 151:13-b.</p>
    </header>
    {e&&<div className="bg-red-50 p-3 rounded-lg text-red-800">{e}</div>}
    <div className="grid grid-cols-1 gap-3 md:grid-cols-3">
      <div className="rounded-2xl border bg-white p-4">
        <div className="text-xs uppercase text-slate-500">Last Meeting</div>
        <div className="text-2xl font-black">{summary.last_meeting_date || 'None logged'}</div>
      </div>
      <div className="rounded-2xl border bg-white p-4">
        <div className="text-xs uppercase text-slate-500">Next Due</div>
        <div className="text-2xl font-black">{summary.next_due_date || '—'}</div>
      </div>
      <div className="rounded-2xl border bg-white p-4">
        <div className="text-xs uppercase text-slate-500">Status</div>
        <div className="mt-1"><span className={`px-3 py-1 rounded-full text-sm font-bold ${badge[summary.status]||badge.overdue}`}>{label[summary.status]||'Overdue'}</span></div>
      </div>
    </div>
    <section className="rounded-2xl border bg-white p-4">
      <h2 className="text-xl font-black">Log a Meeting</h2>
      <div className="mt-3 grid gap-3 md:grid-cols-2">
        <input type="date" className="border p-3" placeholder="Meeting Date" value={f.meeting_date||''} onChange={x=>setF({...f,meeting_date:x.target.value})}/>
        <input className="border p-3" placeholder="Attendees (comma-separated names/roles)" value={f.attendees||''} onChange={x=>setF({...f,attendees:x.target.value})}/>
        <input className="border p-3 md:col-span-2" placeholder="Minutes reference (e.g. filed location, doc ID)" value={f.minutes_document_path||''} onChange={x=>setF({...f,minutes_document_path:x.target.value})}/>
        <textarea className="border p-3 md:col-span-2" placeholder="Topics covered (optional)" value={f.topics_covered||''} onChange={x=>setF({...f,topics_covered:x.target.value})}/>
        <button onClick={add} className="bg-slate-900 p-3 font-bold text-white md:col-span-2 rounded-lg">Log Meeting</button>
      </div>
    </section>
    <section className="rounded-2xl border bg-white p-4">
      <h2 className="text-xl font-black">Meeting History</h2>
      <div className="mt-3 overflow-x-auto">
        <table className="w-full text-sm">
          <thead><tr className="text-left"><th>Date</th><th>Attendees</th><th>Minutes</th><th>Topics</th><th>Next Due</th></tr></thead>
          <tbody>
            {list.map(x=>
              <tr key={x.id} className="border-t">
                <td className="py-3 font-bold">{x.meeting_date}</td>
                <td>{x.attendees.join(', ')}</td>
                <td>{x.minutes_document_path}</td>
                <td>{x.topics_covered || '—'}</td>
                <td>{x.next_meeting_due_date}</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </section>
  </div>;
}
